(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["livecool-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('livecool-product-rail')) {
    customElements.define('livecool-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.lc-product-rail');
        this.controls = this.querySelector('.lc-rail-controls');
        this.update = () => {
          const max = this.rail.scrollWidth - this.rail.clientWidth;
          this.controls.hidden = max <= 1;
          this.controls.children[0].disabled = this.rail.scrollLeft <= 1;
          this.controls.children[1].disabled = this.rail.scrollLeft >= max - 1;
        };
        this.move = event => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const card = this.rail.querySelector('.lc-card');
          if (!card) return;
          this.rail.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.controls.addEventListener('click', this.move);
        this.rail.addEventListener('scroll', this.update, {passive: true});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controls?.removeEventListener('click', this.move);
        this.rail?.removeEventListener('scroll', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livecool-home"]) return;
  try {
    
  if (!customElements.get('livecool-product-rail')) {
    customElements.define('livecool-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.lc-product-rail');
        this.controls = this.querySelector('.lc-rail-controls');
        this.update = () => {
          const max = this.rail.scrollWidth - this.rail.clientWidth;
          this.controls.hidden = max <= 1;
          this.controls.children[0].disabled = this.rail.scrollLeft <= 1;
          this.controls.children[1].disabled = this.rail.scrollLeft >= max - 1;
        };
        this.move = event => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const card = this.rail.querySelector('.lc-card');
          if (!card) return;
          this.rail.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.controls.addEventListener('click', this.move);
        this.rail.addEventListener('scroll', this.update, {passive: true});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controls?.removeEventListener('click', this.move);
        this.rail?.removeEventListener('scroll', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
